import get from 'lodash/get';
import head from 'lodash/head';
import {
  OPEN_POPUP,
  CLOSE_POPUP,
  ADD_DRAFT_WO,
  VALIDATE_CAMPAIGN_ACTION,
  ADD_CAMPAIGN_CODE,
  GET_CAMPAIGN_CODE_SUCCESS,
  GET_CAMPAIGN_CODE_ERROR,
  LOAD_QUOTE_SUCCESS,
  EDIT_LINE_ITEM,
  DELETE_LINE_ITEM,
  SAVE_WORK_OPERATION,
  DELETE_WORK_OPERATION,
  SAVE_QUOTE,
  EDIT_ROW,
  SEND_JOB_INVITE,
  INFOCARD_LOADED,
  WORK_DETAILS_ERROR,
  SAVING_ROW,
  GARAGE_WORK_OPERATION_PRICES,
  GARAGE_WORK_OPERATION_PRICES_SUCCESS,
  GARAGE_WORK_OPERATION_PRICES_ERROR,
  ORIGINAL_WORK_OPERATION_PRICES,
  ORIGINAL_WORK_OPERATION_PRICES_SUCCESS,
  ORIGINAL_WORK_OPERATION_PRICES_ERROR,
  APPROVE_PROPOSED_WORK_OPERATION,
  DECLINE_PROPOSED_WORK_OPERATION,
  FINALISE_PROPOSED_WORK_OPERATION,
  FINALISE_PROPOSED_WORK_OPERATION_SUCCESS,
  FINALISE_PROPOSED_WORK_OPERATION_ERROR,
  SEND_QUOTE_TO_CUSTOMER,
  UPDATE_TO_CUSTOMER_REVIEW,
} from './constants';

export function infocardsLoaded(infocards) {
  return {
    type: INFOCARD_LOADED,
    infocards,
  };
}

export function getGarageWorkOperationPrices(bookingId, garageId) {
  return {
    type: GARAGE_WORK_OPERATION_PRICES,
    bookingId,
    garageId,
  };
}

export function getGarageWorkOperationPricesSuccess(prices) {
  return {
    type: GARAGE_WORK_OPERATION_PRICES_SUCCESS,
    prices,
  };
}

export function getGarageWorkOperationPricesError(err) {
  return {
    type: GARAGE_WORK_OPERATION_PRICES_ERROR,
    err,
  };
}

export function getOriginalWorkOperationPrices(bookingId, garageId) {
  return {
    type: ORIGINAL_WORK_OPERATION_PRICES,
    bookingId,
    garageId,
  };
}

export function getOriginalWorkOperationPricesSuccess(prices) {
  return {
    type: ORIGINAL_WORK_OPERATION_PRICES_SUCCESS,
    prices,
  };
}

export function getOriginalWorkOperationPricesError(err) {
  return {
    type: ORIGINAL_WORK_OPERATION_PRICES_ERROR,
    err,
  };
}

export function closePopupAction() {
  return {
    type: CLOSE_POPUP,
  };
}

export function deleteLineItemAction(operationId) {
  return {
    type: DELETE_LINE_ITEM,
    operationId,
  };
}

export function savingRowAction(savingKey) {
  return {
    type: SAVING_ROW,
    savingKey,
  };
}

export function editRowAction(editingKey) {
  return {
    type: EDIT_ROW,
    editingKey,
  };
}

export function loadQuoteSuccessAction(quote, invite, garage) {
  return {
    type: LOAD_QUOTE_SUCCESS,
    quote,
    invite,
    garage,
  };
}

export function saveQuoteAction() {
  return {
    type: SAVE_QUOTE,
  };
}

/**
 * @deprecated
 */
export function editLineItemAction(lineItem) {
  return {
    type: EDIT_LINE_ITEM,
    lineItem,
  };
}

export function saveWorkOperationAction(data) {
  return {
    type: SAVE_WORK_OPERATION,
    data,
  };
}

export function deleteWorkOperationAction(operationId, quoteType) {
  return {
    type: DELETE_WORK_OPERATION,
    operationId,
    quoteType,
  };
}

export function openPopupAction() {
  return {
    type: OPEN_POPUP,
  };
}

export function addDraftWo(payload) {
  return {
    type: ADD_DRAFT_WO,
    payload,
  };
}

export function checkIsCampaignValid(code) {
  return {
    type: VALIDATE_CAMPAIGN_ACTION,
    code,
  };
}

export function addCampaignCodeAction(campaign) {
  return {
    type: ADD_CAMPAIGN_CODE,
    campaign,
  };
}

export function sendJobInvite(inviteId, note) {
  return {
    type: SEND_JOB_INVITE,
    inviteId,
    note,
  };
}

export function sendQuoteToCustomer() {
  return {
    type: SEND_QUOTE_TO_CUSTOMER,
  };
}

export function updateToCustomerReview() {
  return {
    type: UPDATE_TO_CUSTOMER_REVIEW,
  };
}

export function getCampaignCodeSuccess(campaign) {
  return {
    type: GET_CAMPAIGN_CODE_SUCCESS,
    campaign,
  };
}

export function getCampaignCodeError(err) {
  return {
    type: GET_CAMPAIGN_CODE_ERROR,
    message: get(err, 'response.data.message', err.message),
  };
}

export function workDetailsError(err, quoteData) {
  const error = get(err, 'response.data', err);
  const { statusCode, message, errors } = error;
  let msg = get(errors, '0.message', message);
  if (statusCode === 409) {
    const { accountCode } = head(get(quoteData, 'add', [])) || {};
    switch (accountCode) {
      case '201': // mot
        msg = 'The quote already contains a MOT';
        break;
      case '202': // service
        msg = 'The quote already contains a service';
        break;
      default: // service
        break;
    }
  }
  return {
    type: WORK_DETAILS_ERROR,
    message: msg,
  };
}

export function approveProposedWorkOperation(workOperation) {
  return {
    type: APPROVE_PROPOSED_WORK_OPERATION,
    workOperation,
  };
}

export function declineProposedWorkOperation(workOperation) {
  return {
    type: DECLINE_PROPOSED_WORK_OPERATION,
    workOperation,
  };
}

export function finaliseProposedWorkOperations() {
  return {
    type: FINALISE_PROPOSED_WORK_OPERATION,
  };
}

export function finaliseProposedWorkOperationsSuccess(payload) {
  return {
    type: FINALISE_PROPOSED_WORK_OPERATION_SUCCESS,
    payload,
  };
}

export function finaliseProposedWorkOperationsError(err) {
  return {
    type: FINALISE_PROPOSED_WORK_OPERATION_ERROR,
    payload: err,
  };
}
